export default async function activities (state, appOptions, lastPage, pageOptions) {
  const Activities = (await import(/* webpackChunkName: 'activities' */ '../../apps/agave')).default

  const appState = state.appStates.activities

  // Let the event pass in options that get set on the state model
  const stateOptions = _.pick(pageOptions, 'page', 'group', 'activity')
  const appExtraOptions = _.pick(appOptions, 'allowTrash', 'allowReports')
  appState.set(Object.assign(stateOptions, appExtraOptions))

  if (appState.get('page') === null) {
    appState.changePage('activities')
  }

  return new Activities({
    state: appState
  })
}
